module.exports = __webpack_public_path__ + "img/g7.0cd3920b.jpg";